import { PreviewImage } from "./style";
import { useLegacyEffect } from "helper/customHook";
import { useDispatch, useSelector } from "react-redux";
import { fileResponseSelector } from "redux-store/static/redux/selector";
import { FileTypes, getResponseFileStart } from "redux-store/static/redux/file";
import { REACT_APP_RESTFUL_BASE_URL_FOT_API } from "AppConfig";
import { Skeleton } from "@mui/material";

const ImagePreview = ({ url, fileName }) => {
  const dispatch = useDispatch();
  const ImageUrl = url.split(REACT_APP_RESTFUL_BASE_URL_FOT_API).pop();
  const data = useSelector(fileResponseSelector(ImageUrl));

  useLegacyEffect(() => {
    dispatch(getResponseFileStart({ url: ImageUrl, type: FileTypes.IMAGE }));
  }, []);

  const handlePreviewImage = () => {
    window.open(data, "_blank")?.focus();
  };

  return data ? (
    <PreviewImage src={data} alt={fileName} onClick={handlePreviewImage} />
  ) : (
    <Skeleton variant="rectangular" />
  );
};

export default ImagePreview;
